import { useCallback, useState } from 'react';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import ErrorModal from 'shell/components/shared/modal-error';

export const useCheckPraticheAperte = (): {
  checkPratiche: (cf?: string) => Promise<void>;
  errorModal: React.ReactElement;
} => {
  const [, practiceOpen] = useHttpFetch<HttpResponse<ResponseAnprData>>('', {
    options: {
      method: 'GET',
    },
  });

  const [openModalError, setOpenModalError] = useState<{ open?: boolean; message?: string }>({
    open: false,
    message: '',
  });

  // Controllo pratiche aperte di una persona tramite CF
  const checkPratiche = useCallback(
    (cf?: string) => {
      if (!cf) return Promise.resolve();

      return (
        practiceOpen({
          url: `${__PRACTICE_API_URL__}/pratiche/persone/verifica-pratiche-aperte/${cf}`,
        }) as ResponsePromise<HttpResponse<ResponseAnprData>>
      ).then((response) => {
        if (response?.data.payload.warning) {
          setOpenModalError({
            open: true,
            message: response.data.payload.warning || '',
          });
        }
      });
    },
    [practiceOpen]
  );

  const errorModal = (
    <ErrorModal
      message={openModalError.message || ''}
      open={openModalError.open || false}
      onClose={() => setOpenModalError({ open: false, message: '' })}
    />
  );

  return { checkPratiche, errorModal };
};
